// Update total items count in cart drawer
document.addEventListener('DOMContentLoaded', () => {
  // Function to fetch and update cart item count
  const updateCartItemCount = () => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.getElementById('CartDrawer-TotalItems').textContent = cart.item_count;
      })
      .catch(error => console.error('Error fetching cart:', error));
  };

  // Listen for cart updates (Dawn's cart-drawer triggers this event)
  document.addEventListener('cart:updated', updateCartItemCount);

  // Initial update
  updateCartItemCount();
});